function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
export var DistributedAssetsController =
/*#__PURE__*/
function () {
  _createClass(DistributedAssetsController, null, [{
    key: "$inject",
    get: function get() {
      return ['$stateParams', '$rootScope', 'addelivery.event.constants', '$timeout'];
    }
  }]);

  function DistributedAssetsController($stateParams, $rootScope, EventConstants, $timeout) {
    _classCallCheck(this, DistributedAssetsController);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $stateParams: $stateParams,
      $rootScope: $rootScope,
      EventConstants: EventConstants,
      $timeout: $timeout
    });
    /* BINDABLE : DATA */
    // Add template-ready values here

    /* EVENTS */
    //Register any event listeners
  }
  /* IMPLEMENTATION : BINDABLE */
  // Build template-ready methods here

  /* IMPLEMENTATION : PRIVATE */
  // All private methods should start with '_' in order to distinguish them

  /* INITIALIZATION */


  _createClass(DistributedAssetsController, [{
    key: "$onInit",
    value: function $onInit() {}
  }]);

  return DistributedAssetsController;
}();